module.exports = __webpack_public_path__ + "media/packs/images/back-arrow-2b77138f9d8627f61e1a245466c2e20c.svg";